import { useRouter } from 'next/router';
import { useCallback } from 'react';

export const useBounce = () => {
    const router = useRouter();
    /**
     * Uses router.replace to bounce a user and executes a callback at the new destination.
     *
     * @example
     * bounceAnd('/', () => {
     *     // toast appears on '/' instead of flashing on the current page
     *     // and disappearing on navigation
     *     toast('sorry that location is not currently open', 'warning');
     * });
     */
    const bounceAnd = useCallback(async (path: string, callback: VoidFunction) => {
        await router.replace(path);
        callback();
    }, []);

    return {
        bounceAnd
    };
};

export default useBounce;
